import { useEffect, useRef, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { FaRegUserCircle } from 'react-icons/fa';  // Using react-icons for profile icon

export const ProfileDropdown = ({ user, facility, logout }) => {

  const [show, setShow] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="navbar-profile-dropdown" ref={dropdownRef}>

      {/* Profile Icon */}
      <div
        className="profile-icon"
        onClick={() => setShow((prev) => !prev)}
        style={{ cursor: "pointer" }}
      >
        <FaRegUserCircle size={28} style={{ color: "var(--neo-shades-purple)", zIndex: 100 }} />
      </div>

      {/* Dropdown Menu */}

      {
        show && <div
          className={`dropdown-menu dropdown-menu-end`}
          style={{ minWidth: "200px" }}
        >
          {/* Profile Header */}
          <div className="d-flex profile-header justify-content-center align-items-center py-3">
            <div className='profile-circle'>
              <FaRegUserCircle size={70} className='' style={{ color: "var(--neo-neutral-light-gray)" }} />
            </div>
          </div>

          {/* Profile Body */}
          <div className="profile-body px-3 text-center">
            <h6 className="text-capitalize mb-1">{user.user_name.toLowerCase()}</h6>
            <p className="mb-0">{user.email}</p>
            <p className="text-capitalize mb-0">{user.role.replace("-", " ").toLowerCase()}</p>
            <p>{facility.name}</p>
          </div>

          <div className="dropdown-divider"></div>

          {/* Dropdown Links */}
          <a href="#" className="dropdown-item">
            About
          </a>
          <a href="#" className="dropdown-item">
            Help Center
          </a>

          <div className="dropdown-divider"></div>

          <a href="https://neoneur.com/privacy/" target="_blank" className="dropdown-item">
            Privacy Policy
          </a>
          <a href="https://neoneur.com/terms/" target="_blank" className="dropdown-item">
            Terms of Use
          </a>

          <div className="dropdown-divider"></div>

          <button className="dropdown-item" onClick={logout}>
            Logout
          </button>
        </div>
      }


      {/* Profile Icon */}
      {/* <Dropdown >
        <Dropdown.Toggle as="span" className="profile-icon">
          <FaRegUserCircle size={28} style={{ color: 'var(--neo-shades-purple)' }} />
        </Dropdown.Toggle>

        <Dropdown.Menu>
      <div className="profile-header">
        <div className="profile-placeholder">
          <FaRegUserCircle size={70} style={{ color: 'var(--neo-shades-purple)' }} />
        </div>
      </div>

      <div className="profile-body">
        <h6 className="text-capitalize">{`${user.user_name.toLowerCase()}`}</h6>
        <p>{`${user.email}`}</p>
        <p className="text-capitalize">{`${user.role.replace("-", " ").toLowerCase()}`}</p>
        <p>{facility.name}</p>
      </div>

      <Dropdown.Divider />

      <Dropdown.Item href="#">
        About
      </Dropdown.Item>
      <Dropdown.Item href="#">
        Help Center
      </Dropdown.Item>

      <Dropdown.Divider />


      <Dropdown.Item href="https://neoneur.com/privacy/" target="_blank">
        Privacy Policy
      </Dropdown.Item>
      <Dropdown.Item href="https://neoneur.com/terms/" target="_blank">
        Terms of Use
      </Dropdown.Item>


      <Dropdown.Divider />


      <Dropdown.Item href="#" onClick={logout}>
        Logout
      </Dropdown.Item>

    </Dropdown.Menu>
      </Dropdown > */}
    </div >
  )
}
